import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

/** Brand green back control — white arrow on solid green for clear contrast. */
const BACK_BTN_SX = {
    bgcolor: "#3BA666",
    color: "#fff",
    "&:hover": { bgcolor: "#2e7d32" },
    "& .MuiSvgIcon-root": { color: "#fff" },
};

/**
 * Green circle back button with white arrow.
 * @param {string} [to] — path to navigate to. If omitted, goes back in history.
 * @param {function} [onClick] — custom click handler. Overrides `to` if provided.
 */
export default function IconBack({ to, onClick, sx }) {
    const navigate = useNavigate();

    return (
        <IconButton
            onClick={onClick || (() => (to ? navigate(to) : navigate(-1)))}
            aria-label="Back"
            sx={{ ...BACK_BTN_SX, ...sx }}
            size="small"
        >
            <ArrowBackIcon fontSize="small" />
        </IconButton>
    );
}
